// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"diContainer":"55cd4d223dbd155f0661","ugc-olapic-widget":"68fbead76fdca9a0fd80","src_exported_olapic_OlapicWidget_tsx":"29a9ca237caa318b1b8c"}[chunkId] + ".bundle.js";
};